import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/footer.css';

export default function Footer() {
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        // Pobieramy listę wszystkich ofert z bazy danych
        const response = await axios.get('https://megamont.pl/api/offers');
        setOffers(response.data);
      } catch (error) {
        console.error("Błąd podczas pobierania ofert do stopki:", error);
      }
    };
    fetchOffers();
  }, []);

  return (
    <footer className="Footer">
      <div className="footer-content">
        <div className="footer-columns">
          <div className="footer-col company">
            <h3>Megamont Mariusz Cymbik</h3>
            <p>Sadowiec Wrzosy 46c<br />
              98-355 Działoszyn</p>
            <p>tel. <a href="tel:515238870">515 238 870</a><br />
              e-mail: <a href="mailto:megamont@op.pl">megamont@op.pl</a></p>
            <p>NIP: 772-191-18-82</p>
          </div>
          <div className="footer-col offer">
            <h4>Oferta</h4>
            <ul>
              {offers.length > 0 ? (
                offers.map((offer) => (
                  <li key={offer.id}>{offer.name}</li>
                ))
              ) : (
                <>
                  <li>Konstrukcje Stalowe</li>
                  <li>Zbiorniki</li>
                  <li>Przenośniki</li>
                  <li>Linie Technologiczne</li>
                </>
              )}
            </ul>
          </div>
          <div className="footer-col firma">
            <h4>Firma</h4>
            <ul>
              <li><a href="/offert">Oferta</a></li>
              <li><a href="/realizations">Realizacje</a></li>
              <li><a href="/references">Referencje</a></li>
              <li><a href="/contact">Kontakt</a></li>
            </ul>
          </div>
          <div className="footer-col biuro">
            <h4>Biuro</h4>
            <ul>
              <li>poniedziałek - 08:00–16:00</li>
              <li>wtorek - 08:00–16:00</li>
              <li>środa - 08:00–16:00</li>
              <li>czwartek - 08:00–16:00</li>
              <li>piątek - 08:00–16:00</li>
              <li>sobota/niedziela - Nieczynne</li>
            </ul>
          </div>
        </div>
        <div className="footer-copyright">
          Copyright © 2026 Megamont
        </div>
      </div>
    </footer>
  );
}